import React, { ReactNode, useState } from 'react';
import {
  WixPatternsEssentials,
  WixPatternsEssentialsOverrides,
} from '@wix/bex-core';
import {
  useEssentials,
  useTranslation,
  Trans,
  useExperiments,
} from '@wix/fe-essentials/react';
import {
  AppSettingsStorageStrategy,
  DataCapsule,
} from '@wix/fe-essentials/data-capsule';
import { CairoProvider } from '../providers';
import { WixPatternsContainerOverridesProvider } from '@wix/bex-core/react';
import ExtensionWidget from './ExtensionWidget';
import { Edit } from '@wix/wix-ui-icons-common';

export function WixPatternsEssentialsTestProvider({
  children,
  overrides,
}: {
  children?: ReactNode;
  overrides?: Partial<WixPatternsEssentialsOverrides>;
}) {
  const {
    errorMonitor,
    httpClient,
    environment,
    createChildEssentials,
    experiments,
  } = useEssentials();

  const [value] = useState(
    (): WixPatternsEssentials => ({
      createEssentials: (options) =>
        createChildEssentials({
          ...options,
          experiments:
            options.experiments &&
            'scopes' in options.experiments &&
            options.experiments?.scopes[0] === 'cairo'
              ? {
                  bag: Object.fromEntries(
                    new URLSearchParams(window.location.search)
                      .get('experiments')
                      ?.split(',')
                      ?.map((e) => {
                        const [spec = '', enabled = 'true'] = e.split(':');
                        return [spec, enabled];
                      }) ?? [],
                  ),
                }
              : options.experiments,
        }),
      createComponentSettings: () => () =>
        new DataCapsule({
          namespace: '',
          scope: 'cairo-test',
          strategy: new AppSettingsStorageStrategy({
            host: 'other',
            httpClient,
          }),
        }),
      errorMonitor,
      useTranslation,
      Trans,
      useExperiments: () => useExperiments({ readOnly: true }),
      httpClient,
      experiments,
      ...overrides,
      user: {
        permissions: [],
        ...overrides?.user,
      },
      environment: {
        ...environment,
        componentId: [environment.artifactId, 'cairo-test-component'].join('.'),
        language: 'en-US',
        ...overrides?.environment,
      },
      getHostContainer: (_: string) => ({
        getExtensions: () =>
          Promise.resolve([
            {
              title: 'Extension',
              componentId: '',
              Extension: (props: any) => <ExtensionWidget {...props} />,
              menuItem: {
                IconComponent: Edit,
                structuredAction: () => alert('action'),
              },
            },
          ]),
      }),
    }),
  );

  return (
    <WixPatternsContainerOverridesProvider value={{ appendModalsToBody: true }}>
      <CairoProvider localCache value={value}>
        {children}
      </CairoProvider>
    </WixPatternsContainerOverridesProvider>
  );
}
